/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Lost_ReasonInputs */

const cs_form_lost_reason = /** @type {(inputs: Form_Lost_ReasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Důvod ztráty`)
};

const en_form_lost_reason = /** @type {(inputs: Form_Lost_ReasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lost reason`)
};

/**
* | output |
* | --- |
* | "Lost reason" |
*
* @param {Form_Lost_ReasonInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_lost_reason = /** @type {((inputs?: Form_Lost_ReasonInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Lost_ReasonInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_lost_reason(inputs)
	return cs_form_lost_reason(inputs)
});